<template>
    <Head>
        <title>Fiat Gateway: Реквизиты</title>
    </Head>

    <authenticated-layout :notifications="notifications" >
        <v-navigation :gateway="{id:gatewayId}"/>
        <form action="#" method="post"
              @submit.prevent="create"
              class="grid grid-cols-5 items-center p-6 gap-6 bg-white"
        >
            <v-toggle label="Активен" v-model="add.isActive" :error="errors.isActive"/>
            <v-input class="col-span-2" label="Название" v-model="add.name" :error="errors.name" />
            <v-input-json class="col-span-2" label="Параметры" v-model="add.credentials" :error="errors.credentials" />
            <div class="col-span-full flex flex-row justify-end">
                <v-button>Добавить</v-button>
            </div>
        </form>
        <div class="grid grid-cols-5 items-stretch p-6 gap-6 border-t bg-white" v-for="cred in result">
            <v-toggle label="Активен" v-model="cred.isActive" @change="setActive(cred)"/>
            <div class="col-span-2 flex flex-col gap-2 justify-between">
                <v-input class="col-span-2" label="Название" v-model="cred.name"  @input="cred.nameUpdate = true"/>
                <v-button @click="setName(cred)" :disabled="!cred.nameUpdate">Обновить название</v-button>
            </div>
            <div class="col-span-2 flex flex-col gap-2 justify-between">
                <v-input-json label="Параметры" v-model="cred.credentials" @input="cred.credUpdate = true" />
                <v-button @click="setCredentials(cred)" :disabled="!cred.credUpdate">Обновить параметров</v-button>
            </div>
        </div>
    </authenticated-layout>
</template>

<script>

import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import VNavigation from '@/Components/Navigation/FiatGateways';
import VTable from '@/Components/Tables/FiatGateways/Credentials';
import VButton from "@/Components/Button.vue";
import VInputJson from "@/Components/InputJson.vue";
import VToggle from "@/Components/Toggle.vue";
import VInput from "@/Components/Input.vue";

export default {
    components: {
        VInput, VToggle, VInputJson, VButton,
        Head, Link,
        AuthenticatedLayout,
        VNavigation,
        VTable,
    },
    props: {
        errors:Object,
        success: Boolean,
        result: Object,
        gatewayId: Number,
        notifications: Array,
    },
    data() {
        return {
            add: {
                name: '',
                isActive: false,
                credentials: {
                    apiKey: '',
                },
            },
        }
    },
    methods: {
        create() {
            const { notifications, route, add, gatewayId } = this;
            notifications.push({
                type: 'success',
                title: 'Добавление реквизитов',
                message: 'Отправка данных...',
                timeout: false,
            });
            useForm({
                gatewayId: gatewayId ,
                name: add.name,
                isActive: add.isActive,
                credentials: add.credentials,
            }).post(route('fiat.credential.create'));
        },
        setActive(cred) {
            const {notifications} = this;
            notifications.push({
                type: 'success',
                title: cred.isActive ? 'Включение реквизита' : 'Отключение реквизита',
                message: 'Отправка данных...',
                timeout: false,
            });
            useForm({
                isActive: cred.isActive,
            }).post(this.route('fiat.credential.set.active', cred.id));
        },
        setName(cred) {
            cred.nameUpdate = false;
            const {notifications} = this;
            notifications.push({
                type: 'success',
                title: 'Обновление названия',
                message: 'Отправка данных...',
                timeout: false,
            });
            useForm({
                name: cred.name,
            }).post(this.route('fiat.credential.set.name', cred.id));
        },
        setCredentials(cred) {
            cred.credUpdate = false;
            const {notifications} = this;
            notifications.push({
                type: 'success',
                title: 'Обновление параметров',
                message: 'Отправка данных...',
                timeout: false,
            });
            useForm({
                credentials: cred.credentials,
            }).post(this.route('fiat.credential.set.credentials', cred.id));
        },
    },

};
</script>
